import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Slider,
  Stack,
  Typography,
  Zoom,
  styled,
} from "@mui/material";

const GRID_MAX = 6;
const GRID_MIN = 1;

const UnifiedDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    borderRadius: "16px",
    padding: theme.spacing(2),
    boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
  },
}));

const AddGridDialog = ({
  open,
  onClose,
  onConfirm,
  title = "Aggiungi layout",
  initialRows = 1,
  initialColumns = 1,
  confirmLabel = "Aggiungi",
}) => {
  const [rows, setRows] = React.useState(initialRows);
  const [columns, setColumns] = React.useState(initialColumns);

  React.useEffect(() => {
    if (open) {
      setRows(Math.min(GRID_MAX, Math.max(GRID_MIN, initialRows)));
      setColumns(Math.min(GRID_MAX, Math.max(GRID_MIN, initialColumns)));
    }
  }, [open, initialRows, initialColumns]);

  return (
    <UnifiedDialog open={open} onClose={onClose} maxWidth="xs" fullWidth slots={{ transition: Zoom }}>
      <DialogTitle sx={{ textAlign: "center", fontWeight: 700, color: "#0b3d87", pb: 0 }}>
        {title}
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 2 }}>
          <Typography variant="caption" color="text.secondary">
            Scegli quante righe e colonne deve avere la griglia (massimo {GRID_MAX}).
          </Typography>
          <Typography variant="caption">Righe: {rows}</Typography>
          <Slider
            size="small"
            min={GRID_MIN}
            max={GRID_MAX}
            step={1}
            value={rows}
            onChange={(_, val) => setRows(val)}
            marks
          />
          <Typography variant="caption">Colonne: {columns}</Typography>
          <Slider
            size="small"
            min={GRID_MIN}
            max={GRID_MAX}
            step={1}
            value={columns}
            onChange={(_, val) => setColumns(val)}
            marks
          />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", pb: 2, gap: 1 }}>
        <Button onClick={onClose}>Annulla</Button>
        <Button variant="contained" onClick={() => onConfirm(rows, columns)}>
          {confirmLabel}
        </Button>
      </DialogActions>
    </UnifiedDialog>
  );
};

AddGridDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string,
  initialRows: PropTypes.number,
  initialColumns: PropTypes.number,
  confirmLabel: PropTypes.string,
};

export default AddGridDialog;
 